import React from "react";
import { Info, MapPin, Award } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const employees = [{
  name: "Travis & Deborah\nTaillet",
  position: "OWNERS / REALTOR",
  bio: "Over 3 years of experience in Abilene real estate, graduated from Howard Payne University and McMurry University. Have served over 13 years in the Texas Army National Guard.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553193/img/jane_doe_portrait.png",
  specialty: "Market Analysis & Strategy",
  nameClassName: "aspect-[4/5] w-full overflow-hidden bg-muted relative !bg-[url(https://possible-pig.10web.cloud/wp-content/uploads/2026/02/Screenshot-2026-02-21-at-8.53.26-PM.png)] bg-contain bg-center"
}, {
  name: "\n",
  position: "\n",
  bio: "Dedicated professional with extensive experience in the Abilene rental market, committed to providing exceptional service to both owners and tenants through proactive management and clear communication.",
  specialty: "Tenant Relations & Operations",
  nameClassName: "aspect-[4/5] w-full overflow-hidden bg-muted relative bg-cover bg-center aspect-[4/5] w-full overflow-hidden bg-muted relative"
}];
export default function TheManagementTeam() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="the-management-team" ref={ref} className="py-24 bg-background relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-64 bg-gradient-to-b from-muted/30 to-transparent pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground mb-6">
            The Management Team
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Meet the dedicated professionals behind Taillet Real Estate. We blend
            local Abilene expertise with industry-leading property management
            practices to serve owners and residents alike.
          </p>
        </div>

        <div className={`mb-16 transition-all duration-700 delay-300 ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
          
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto justify-center">
          {employees.map((employee, i) => <div key={employee.name} data-index={i} className={`transition-all duration-700 delay-${i * 200} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              <Card className="h-full border-none shadow-sm hover:shadow-xl transition-all duration-300 bg-card overflow-hidden group">
                <CardHeader className="p-0">
                  <div className={`${employee.nameClassName || ""} aspect-[4/5] w-full overflow-hidden bg-muted relative`}>
                    {!employee.nameClassName}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-6">
                      <span className="text-white font-medium tracking-wide text-sm bg-black/20 backdrop-blur-sm px-4 py-1 rounded-full border border-white/30">
                        View Expertise
                      </span>
                    </div>
                  </div>
                </CardHeader>
                <CardContent className="text-center pt-8 pb-10 px-6">
                  <HoverCard>
                    <HoverCardTrigger asChild>
                      <div className="cursor-help inline-block">
                        <CardTitle className="text-2xl font-serif mb-2 group-hover:text-primary transition-colors whitespace-pre-line">
                          {employee.name}
                        </CardTitle>
                        <CardDescription className="text-base font-medium text-primary uppercase tracking-widest text-xs">
                          {employee.position}
                        </CardDescription>
                      </div>
                    </HoverCardTrigger>
                    <HoverCardContent className="w-80 p-0 overflow-hidden border-border/50 shadow-xl">
                      <div className="p-4 bg-popover">
                        <p className="text-sm text-muted-foreground leading-relaxed mb-4">
                          {employee.bio}
                        </p>
                        <div className="flex items-center gap-2 text-xs text-muted-foreground pt-2 border-t border-border/50">
                          <MapPin className="w-3 h-3" />
                          <span>Serving Abilene, Texas</span>
                        </div>
                      </div>
                    </HoverCardContent>
                  </HoverCard>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}